import React from 'react';
import { useStyletron } from 'baseui';

import { EMPTY_OBJECT, FormBuilder } from 'commons-ui';
import { CREDIT_FORM_LAYOUT_CONFIG, CREDIT_FORM_FIELD_CONFIG } from '../../utils/formConfig';
import { ContentPropsT } from '../../kindReward.model';
import useCredit from '../../utils/useCredit';

const Content = (props: ContentPropsT) => {
	const { onClose, handleRewardCredit, handleFilterSubmit, rowData } = props;
	const [css] = useStyletron();

	const { showLoader, setShowLoader, handleFormSubmit, handleFormCancel } = useCredit({
		handleFilterSubmit,
		onClose,
		handleRewardCredit,
		rowData
	});

	return (
		<div className={css({ width: '50vw' })}>
			<FormBuilder
				data={EMPTY_OBJECT}
				mode='create'
				showLoader={showLoader}
				handleFormSubmit={handleFormSubmit}
				handleFormCancel={handleFormCancel}
				setShowLoader={setShowLoader}
				fieldConfig={CREDIT_FORM_FIELD_CONFIG}
				layoutConfig={CREDIT_FORM_LAYOUT_CONFIG}
				buttonLabels={{
					submitLabel: 'Submit',
					discardLabel: 'Cancel'
				}}
				hidePopUp
				validationSchema={null}
			/>
		</div>
	);
};

export default Content;
